import React from 'react';

import { Text } from '@betterment/samba-react';
import { Box, Flash } from '@betterment/style-closet-react';
import { ErrorMessage } from 'formik';

const FlashErrorMessage: React.FC<React.PropsWithChildren<{ name: string }>> = ({ name }) => {
  return (
    <ErrorMessage name={name}>
      {msg => (
        <Box mb="9">
          <Flash variant="error">
            <Text role="alert">{msg}</Text>
          </Flash>
        </Box>
      )}
    </ErrorMessage>
  );
};

export default FlashErrorMessage;
